export enum UserLoginType {
  PERSONAL = "personal",
  PROFESSIONAL = "professional",
  INVITED = "invited"
}
